export const ONR_GenericTestsReportSchema = {
  sections: [
    {
      heights: {
        header1: "auto",
        header2: "auto",
      },
      minDataRowsCount: 3,
      columns: [
        {
          title: "Test Description",
          colSpan: 7,
          rowSpan: 1,
          className: "tbl-text-normal",
          accessor: "title",
          dataClassName: "text-left pd-left-10px d-block"
        },
        {
          title: "Condition Left",
          colSpan: 3,
          rowSpan: 1,
          className: "tbl-text-normal",
          accessor: "summary.test"
        },
        {
          title: "Comments",
          colSpan: 10,
          rowSpan: 1,
          className: "tbl-text-normal",
          dataClassName: "text-left pd-left-10px d-block",
          accessor: 'summary.com'
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/Reports/ONR/GenericTestsReport/ONR_GenericTestsReportSchema.js